import type { ApolloClient } from "@apollo/client";
import { DataConnectionId, SchemaElementSearchResultType } from "@hex/common";

import type { SchemaSearchHelpers } from "./sqlCompletionItems";
import {
  SearchSchemaForSqlCompletionProviderDocument,
  SearchSchemaForSqlCompletionProviderQuery,
  SearchSchemaForSqlCompletionProviderQueryVariables,
} from "./SqlCompletionProvider.generated";

export const SQL_COMPLETION_RESULT_LIMIT = 100;

export function createSqlSchemaSearch(
  apolloClient: ApolloClient<unknown>,
  dataConnectionId: DataConnectionId,
): SchemaSearchHelpers {
  return {
    getDatabases: async (query) => {
      const data = await apolloClient.query<
        SearchSchemaForSqlCompletionProviderQuery,
        SearchSchemaForSqlCompletionProviderQueryVariables
      >({
        query: SearchSchemaForSqlCompletionProviderDocument,
        variables: {
          dataConnectionId,
          resultTypes: [SchemaElementSearchResultType.DATABASES],
          query,
          limit: SQL_COMPLETION_RESULT_LIMIT,
          schemaFilters: null,
          columnFilters: null,
          tableFilters: null,
        },
      });
      return data.data.searchSchemaElements.databases;
    },
    getSchemas: async (query, { filters } = {}) => {
      const data = await apolloClient.query<
        SearchSchemaForSqlCompletionProviderQuery,
        SearchSchemaForSqlCompletionProviderQueryVariables
      >({
        query: SearchSchemaForSqlCompletionProviderDocument,
        variables: {
          dataConnectionId,
          resultTypes: [SchemaElementSearchResultType.SCHEMAS],
          query,
          limit: SQL_COMPLETION_RESULT_LIMIT,
          schemaFilters: filters ?? null,
          columnFilters: null,
          tableFilters: null,
        },
      });
      return data.data.searchSchemaElements.schemas;
    },
    getTables: async (query, { filters } = {}) => {
      const { data } = await apolloClient.query<
        SearchSchemaForSqlCompletionProviderQuery,
        SearchSchemaForSqlCompletionProviderQueryVariables
      >({
        query: SearchSchemaForSqlCompletionProviderDocument,
        variables: {
          dataConnectionId,
          resultTypes: [SchemaElementSearchResultType.TABLES],
          query,
          limit: SQL_COMPLETION_RESULT_LIMIT,
          schemaFilters: null,
          columnFilters: null,
          tableFilters: filters ?? null,
        },
      });
      return data.searchSchemaElements.tables;
    },
    getColumns: async (query, { filters } = {}) => {
      const { data } = await apolloClient.query<
        SearchSchemaForSqlCompletionProviderQuery,
        SearchSchemaForSqlCompletionProviderQueryVariables
      >({
        query: SearchSchemaForSqlCompletionProviderDocument,
        variables: {
          dataConnectionId,
          resultTypes: [SchemaElementSearchResultType.COLUMNS],
          query,
          limit: SQL_COMPLETION_RESULT_LIMIT,
          schemaFilters: null,
          tableFilters: null,
          columnFilters: filters ?? null,
        },
      });
      return data.searchSchemaElements.columns;
    },
  };
}
